module.exports = __webpack_public_path__ + "bf.svg?86ef8150c29ad916a2001ce020a62059";